import { LoadingButton } from '@mui/lab';
import { Box, Stack, styled, Typography } from '@mui/material';
import React, { useState } from 'react';
import palette from '../../../../theme/palette';
import useLocales from '../../../../hooks/useLocales';
import Iconify from '../../../../components/Iconify';
import CustomModal from '../../../../components/CustomModal';
import { TELEGRAM_REGISTER_LINK } from '../../../../config';

const RegisterTelegramButton = styled(LoadingButton)(({ theme }) => ({
  width: '100%',
  marginBottom: 8,
  color: palette.visitor.login.color,
  fontWeight: 500,
  backgroundColor: '#0088cc',
  '&:hover': {
    backgroundColor: '#007ab8',
  },
}));

const InstructionOL = styled('ol')(({ theme }) => ({
  listStyleType: 'decimal',
  paddingLeft: theme.spacing(4),
  fontSize: '1rem',
}));

const InstructionText = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  fontWeight: 300,
  marginBottom: '1rem',
  '& b': {
    fontWeight: 900,
  },
}));

/**
 * Highlights all occurrences of a keyword in the text by wrapping them with <b> tags.
 *
 * @param {string} text - The full text to process
 * @param {string} keyword - The word/phrase to highlight
 * @returns JSX with <b> wrapping the matched parts
 */
function highlightText(text, keyword) {
  if (!keyword) return text;

  const parts = text.split(new RegExp(`(${keyword})`, 'gi'));

  return parts.map((part, index) => (part.toLowerCase() === keyword.toLowerCase() ? <b key={index}>{part}</b> : part));
}

export const TelegramRegister = () => {
  const { translate } = useLocales();

  const [isLoading, setIsLoading] = useState(false);

  const [openInstruction, setOpenInstruction] = useState(false);

  const onJoinClick = () => {
    window.open(TELEGRAM_REGISTER_LINK, '_blank');
  };

  if (!TELEGRAM_REGISTER_LINK) return <></>;

  return (
    <>
      <RegisterTelegramButton
        type="button"
        fullWidth
        variant="contained"
        loading={isLoading}
        sx={{ fontWeight: 600 }}
        startIcon={<Iconify icon={'mingcute:telegram-fill'} />}
        onClick={() => setOpenInstruction(true)}
      >
        {translate('register_with_telegram')}
      </RegisterTelegramButton>

      <CustomModal
        open={openInstruction}
        title={translate('registration_method')}
        onClose={() => setOpenInstruction(false)}
      >
        <Stack sx={{ px: 1, pb: 1, pt: 4 }} spacing={1}>
          <InstructionOL>
            <li>
              <InstructionText>{highlightText(translate('reg_instruction_1'), 'Join GoldCity99')}</InstructionText>
            </li>
            <li>
              <InstructionText>{highlightText(translate('reg_instruction_2'), 'Share My Contact')}</InstructionText>
            </li>
            <li>
              <InstructionText>{translate('reg_instruction_3')}</InstructionText>
            </li>
            <li>
              <InstructionText>{highlightText(translate('reg_instruction_4'), '000000')}</InstructionText>
            </li>
            <li>
              <InstructionText>{translate('reg_instruction_5')}</InstructionText>
            </li>
            <li>
              <InstructionText>{translate('reg_instruction_6')}</InstructionText>
            </li>
          </InstructionOL>

          <RegisterTelegramButton onClick={onJoinClick}>Join GoldCity99</RegisterTelegramButton>
        </Stack>
      </CustomModal>
    </>
  );
};
